import React from 'react';
import {MdTextField, MdCheckbox} from 'core/components/fields/fields';
import {createForm} from 'core/form/createForm';
import {FieldText, lovLabel, FormProps, ClosedContentProps} from 'core/form/formUtils';
import StyledSelect from 'core/components/fields/styledSelect';
import {BlockComp} from 'core/components/blockComp/blockComp';
import ActiveItem from 'core/components/blockComp/activeItem';
import {Validate} from 'core/form/validate';
import {PrimaryKeyString} from 'core/form/rules';
import {ActivityConfig} from "core/event/eventDomain";
import {observer} from "mobx-react";
import {DefinitionType, FIELDDEFDISPLAYTYPE} from "core/form/form";


interface ActivityConfigFormProps extends FormProps<ActivityConfig, ActivityConfig> {
  onRootEntitySuccess: () => void;
}

@observer
class ActivityConfigForm extends React.Component<ActivityConfigFormProps, undefined> {




  render() {


    let {dataObject, rootObject, entities, entity} = this.props;
    let fields = dataObject.getFormFields(definition.formName);
    let {activityConfigId, activityName, comment, activityType, rootEntity, location, activityCategory} = fields;

    let openContent = (
      <div>

        <div className="row">
          <div className="fx col-xs-12 col-sm-5">
            <MdTextField {...activityConfigId.props} disabled={!dataObject.$new} />
            <Validate field={activityConfigId} value={activityConfigId.props.value}>
              <PrimaryKeyString/>
            </Validate>
          </div>
          <div className="fx col-xs-12 col-sm-7">
            <MdTextField {...activityName.props} />
            <Validate field={activityName} value={activityName.props.value}/>
          </div>
          <div className="fx col-xs-6">
            <StyledSelect {...activityType.props} />
            <Validate field={activityType} value={activityType.props.value}/>
          </div>
          <div className="fx col-xs-6">
            <StyledSelect {...activityCategory.props} />
            <Validate field={activityCategory} value={activityCategory.props.value}/>
          </div>
          <div className="fx col-xs-6">
            <StyledSelect {...rootEntity.props} />
            <Validate field={rootEntity} value={rootEntity.props.value} onSuccess={this.props.onRootEntitySuccess} />
          </div>
          <div className="fx col-xs-6">
            <StyledSelect {...location.props} />
          </div>
        </div>

        <div className="row">
          <div className="fx col-xs-12">
            <MdTextField {...comment.props} multiLine={true} rows={2}  />
          </div>
        </div>

      </div>
    );



    return (
      <BlockComp noPadding >
        <ActiveItem openContent={openContent} closedContent={<ClosedContent {...{dataObject, entity, entities, fields}} />} validate={this.props.validate} {...this.props} />
      </BlockComp>
    );
  }
}

const ClosedContent = ({dataObject, entity, entities, fields, disabled}: ClosedContentProps<ActivityConfig>) => (
  <div style={{display: 'flex', flexDirection: 'column'}}>

    <h5 style={{marginTop: 0, fontSize: '18px', fontWeight: 'bold'}}> <span className="zz-grey-text">{lovLabel(dataObject.activityType)}</span> {dataObject.activityName}</h5>

    <div className="form-text-row">
      <FieldText label={fields.activityCategory.textLabel} value={dataObject.activityCategory}/>
    </div>

    <div className="form-text-row">
      <FieldText label={fields.activityConfigId.textLabel} value={dataObject.activityConfigId}/>
      <FieldText label={fields.rootEntity.textLabel} value={dataObject.rootEntity}/>
      <FieldText label={fields.location.textLabel} value={dataObject.location}/>
    </div>

    <div className="form-text-row">
      <FieldText label={fields.comment.textLabel} value={dataObject.comment}/>
    </div>

  </div>
);

const definition: DefinitionType = {
  formName: 'ActivityConfigForm',
  fields: [{
    name: 'activityConfigId',
    validators: ['IsRequired']
  }, {
    name: 'activityName',
    validators: ['IsRequired']
  }, {
    name: 'comment',
    displayType: FIELDDEFDISPLAYTYPE.textArea
  }, {
    name: 'activityType',
    validators: ['IsRequired']
  }, {
    name: 'rootEntity',
    validators: ['IsRequired']
  }, {
    name: 'location'
  }, {
    name: 'activityCategory',
    validators: ['IsRequired']
  }]
};

export default createForm(definition, ClosedContent)(ActivityConfigForm);




// WEBPACK FOOTER //
// ./src/core/event/component/activityConfigForm.tsx